import React, { useState } from 'react';
import { Form, Input, Button, DatePicker, Select, message, Upload, Modal } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { useSelector } from "react-redux";
import Dropdown from "../../components/search/Dropdown";
import { fetchDataForDropdown } from "../../services/Service";
import './SkillRepo.css';

const skills = ["JavaScript", "React", "Node.js", "Python", "Java"];
const experienceLevels = ["1-3 years", "3-6 years", "6+ years"];
const certifications = ["AWS", "Azure", "Google Cloud", "PMP"];
const visaCountries = ["United Kingdom", "United States of America"];
const mentors = ["John Doe", "Jane Smith", "Emily Brown"];
const accounts = ["Account A", "Account B", "Account C"];

const EditSkillRepo = () => {
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [form] = Form.useForm();
  const token = useSelector((state) => state.auth.token);

  const handleSubmit = async (values) => {
    try {
      setLoading(true);
      if (!values.mainSkillset) throw new Error("Main Skillset is mandatory");
      setTimeout(() => {
        message.success('Form submitted successfully!');
        console.log('Submitted Data:', values);
        form.resetFields();
        setModalVisible(false);
        setLoading(false);
      }, 1000);
    } catch (err) {
      setLoading(false);
      message.error(err.message || "Something went wrong");
    }
  };

  const handleFileUpload = (info) => {
    if (info.file.status === 'done') {
      message.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === 'error') {
      message.error(`${info.file.name} file upload failed.`);
    }
  };

  return (
    <div className="form-container">
      <Button type="primary" onClick={() => setModalVisible(true)}>Edit Skill Repo Form</Button>

      <Modal
        title={<div style={{ textAlign: "center", fontSize: "20px", fontWeight: "bold" }}>Skill Repository Form</div>}
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={null}
        width={800}
      >
        <Form form={form} onFinish={handleSubmit} layout="horizontal" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
          <Form.Item label="ID" name="id"><Input disabled /></Form.Item>
          <Form.Item label="Name" name="name"><Input disabled /></Form.Item>

          <Form.Item label="Actual Birthday" name="birthdayDay" rules={[{ required: true, message: 'Please select birth day' }]}>
            <Select placeholder="Select Day">
              {Array.from({ length: 31 }, (_, i) => i + 1).map(day => (
                <Select.Option key={day} value={day}>{day}</Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item label="Actual Birth Month" name="birthMonth" rules={[{ required: true, message: 'Please select birth month' }]}> 
            <DatePicker picker="month" style={{ width: '100%' }} />
          </Form.Item>

          <Form.Item label="Walmart Joining Date" name="joiningDate" rules={[{ required: true, message: 'Please select joining date' }]}> 
            <DatePicker style={{ width: '100%' }} />
          </Form.Item>

          <Form.Item label="Walmart Login ID" name="loginId" rules={[{ required: true, message: 'Walmart Login ID required' }]}> 
            <Input placeholder="Enter Walmart Login ID" />
          </Form.Item>

          <Form.Item label="Walmart System Name" name="systemId" 
          rules={[{ required: true, message: 'Walmart System ID required' }]}> 
            <Input placeholder="Enter Walmart System  ID" />
          </Form.Item>

          <Form.Item label="Overall Experience" name="experience" rules={[{ required: true, message: 'Select experience level' }]}> 
            <Select placeholder="Experience Level">{experienceLevels.map(l => (<Select.Option key={l} value={l}>{l}</Select.Option>))}</Select>
          </Form.Item>

          <Form.Item label="Main Skillset" name="mainSkillset" rules={[{ required: true, message: 'Main skillset is required' }]}> 
            <Select placeholder="Select Skill">{skills.map(s => (<Select.Option key={s} value={s}>{s}</Select.Option>))}</Select>
          </Form.Item>

          <Form.Item label="Experience in Main Skillset" name="experienceMainSkill" 
          rules={[{ required: true, message: 'Select experience level' }]}> 
            <Select placeholder="Experience in Main Skillset Level">{experienceLevels.map(l => (<Select.Option key={l} value={l}>{l}</Select.Option>))}</Select>
          </Form.Item>

          <Form.Item
            label={
              <>
                Additional Skillset <br />
                where you have expertise
              </>
            }
            name="additionalExperience"
          > 
            <Select placeholder="Additional Skillset Experience Level">
              {experienceLevels.map(l => (
                <Select.Option key={l} value={l}>{l}</Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item label="Certifications" name="certifications" rules={[{ required: true, message: "Select at least one certification!" }]}>
            <Select mode="multiple" placeholder="Select Certifications">{certifications.map(c => (<Select.Option key={c} value={c}>{c}</Select.Option>))}</Select>
          </Form.Item>

          <Form.Item label="Comments" name="comments"><Input.TextArea placeholder="Enter details" /></Form.Item>

          <Form.Item label="Hobbies" name="hobbies"><Input.TextArea placeholder="Your hobbies" /></Form.Item>

          <Form.Item label="Upload Resume in UST Format" name="resume">
            <Upload name="resume" action="/upload" listType="text" onChange={handleFileUpload} showUploadList={false}>
              <Button icon={<UploadOutlined />}>Upload Resume</Button>
            </Upload>
            <a href="/downloads/Resume_Template.docx" download style={{ marginLeft: "10px", fontWeight: "bold" }}>Download Template</a>
          </Form.Item>

          <Form.Item label="Visa Country" name="visaCountry">
            <Select placeholder="Select Visa Country">{visaCountries.map(v => (<Select.Option key={v} value={v}>{v}</Select.Option>))}</Select>
          </Form.Item>

          <Form.Item label="Mentor" name="mentor">
            <Select placeholder="Select Mentor">{mentors.map(m => (<Select.Option key={m} value={m}>{m}</Select.Option>))}</Select>
          </Form.Item>

          <Form.Item label="Account" name="account">
            <Select placeholder="Select Account">{accounts.map(a => (<Select.Option key={a} value={a}>{a}</Select.Option>))}</Select>
          </Form.Item>

          <Form.Item label="Location" name="location">
            <Dropdown fetchData={() => fetchDataForDropdown("locations")} placeholder="Select Location" includeAll={true} />
          </Form.Item>

          <Form.Item wrapperCol={{ span: 24 }} style={{ textAlign: "right" }}>
            <Button type="primary" htmlType="submit" loading={loading}>Update</Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default EditSkillRepo;
